export var CreateAgentStatus;
(function (CreateAgentStatus) {
    CreateAgentStatus["Error"] = "Error";
    CreateAgentStatus["Success"] = "Success";
    CreateAgentStatus["NoAgentAvailable"] = "NoAgentAvailable";
})(CreateAgentStatus || (CreateAgentStatus = {}));
